import { ReactNode, createContext, useEffect } from 'react'

import { loadPartnerAdsUrlParameters } from './partner-ads'

interface PartnerAdsContextProps {
  partnerAdsEnabled: boolean
}

interface PartnerAdsContextProviderProps {
  partnerAdsEnabled: boolean
  children: ReactNode
}

export const PartnerAdsContext = createContext<PartnerAdsContextProps>({
  partnerAdsEnabled: false,
})

export const PartnerAdsContextProvider = ({
  partnerAdsEnabled,
  children,
}: PartnerAdsContextProviderProps) => {
  // Load PartnerAds parameters on page load
  useEffect(() => {
    if (!partnerAdsEnabled) {
      return
    }

    loadPartnerAdsUrlParameters()
  }, [partnerAdsEnabled])

  return (
    <PartnerAdsContext.Provider
      value={{
        partnerAdsEnabled,
      }}
    >
      {children}
    </PartnerAdsContext.Provider>
  )
}
